var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.9988C18 18.5511 17.5523 18.9988 17 18.9988H1C0.44772 18.9988 0 18.5511 0 17.9988V7.48785C0 7.17926 0.14247 6.88795 0.38606 6.6985L8.3861 0.47627C8.7472 0.19541 9.2528 0.19541 9.6139 0.47627L17.6139 6.6985C17.8575 6.88795 18 7.17926 18 7.48785V17.9988ZM16 16.9988V7.97693L9 2.53249L2 7.97693V16.9988H16Z",
    fill: "#40444E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.14d35c7406a84c1b9fddf96225a33250.svg";
export { ForwardRef as ReactComponent };